import(/* webpackMode: "eager" */ "/app/src/app/privacy-policy/page.tsx");
